import { render, staticRenderFns } from "./maskProblem.vue?vue&type=template&id=1fd7797a&"
import script from "./maskProblem.vue?vue&type=script&lang=js&"
export * from "./maskProblem.vue?vue&type=script&lang=js&"
import style0 from "./maskProblem.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports